import mongoose from "mongoose";

export interface Document {
  _id: mongoose.Schema.Types.ObjectId;
  customerId: string;
  entity: string;
  entityId: string;
  documentType: string;
  s3Key?: string;
  sdmId?: mongoose.Schema.Types.ObjectId;
  uploaded: boolean;
  fileName: string;
  contentType: string;
  createdAt: Date;
}

export const DocumentSchema = new mongoose.Schema<Document>({
  customerId: { type: String },
  entity: String, // e.g. "Order"
  entityId: String, // the ID of the `entity`
  documentType: String, // e.g. "Purchase Order"
  s3Key: String, // whole path to item in S3 (not including bucket)
  sdmId: mongoose.Schema.Types.ObjectId, // ObjectID for SDM Doc instead of s3Key
  uploaded: Boolean, // set to true once doc is uploaded
  fileName: String, // original name of file
  contentType: String, // optional, S3 should know anyway
  createdAt: { type: Date, default: Date.now },
});

DocumentSchema.index({
  customerId: 1,
  entity: 1,
});

DocumentSchema.index({
  entity: 1,
  entityId: 1,
  documentType: 1,
});
